import { FETCH_ORDER_DETAILS_REQUEST, FETCH_ORDER_DETAILS_SUCCESS, FETCH_ORDER_DETAILS_ERROR } from '../constants/ActionTypes'

export default function fetchOrderDetailsError(state = false, action) {
    switch (action.type) {
        case FETCH_ORDER_DETAILS_REQUEST:
        case FETCH_ORDER_DETAILS_SUCCESS:
            return false

        case FETCH_ORDER_DETAILS_ERROR:
            return true
        default:
            return state
    }
}
